import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import {getEmployeeProfile, getEmployeeWorkHistory} from "../../Api/Api";
import {useWorkshop} from "../Common/WorkshopContext";
import EmployeeReportChart from "./EmployeeReport";
import {useNotification} from "../Notification/NotificationContext";

const EmployeeProfile = () => {
    const [employeeData, setEmployeeData] = useState(null);
    const [workHistory, setWorkHistory] = useState([]);
    const { employeeId } = useParams();
    const { workshopId } = useWorkshop();
    const { showNotification } = useNotification();

    useEffect(() => {
        fetchEmployeeData();
        fetchEmployeeWorkHistory();
    }, [employeeId]);

    const fetchEmployeeData = async () => {
        try {
            const res = await getEmployeeProfile(employeeId);
            setEmployeeData(res.data);
        } catch (error) {
             showNotification(error.message, "error")
        }
    };

    const fetchEmployeeWorkHistory = async () => {
        try {
            const res = await getEmployeeWorkHistory(employeeId);
            setWorkHistory(res.data);
        } catch (error) {
            showNotification({message:error, type: "error"})
        }
    };

    if (!employeeData) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500"></div>
            </div>
        );
    }

    return (
        <div className="mt-6">
            <div className="max-w-screen-xl mx-auto">
                <div className="bg-white shadow-lg rounded-lg overflow-hidden">
                    <div className="bg-teal-400 text-white p-3 rounded-t-lg flex justify-between items-center">
                        <h2 className="text-xl font-semibold">Employee Profile</h2>
                    </div>
                    <div className="p-6">
                        <div className="flex items-center space-x-6">
                            <img src='/img/male-profile.png' alt="Profile" className="w-24 h-24 rounded-full border-2 border-gray-300" />
                            <div>
                                <h3 className="text-2xl font-semibold">{employeeData.name}</h3>
                                <p className="text-gray-600">{employeeData.position}</p>
                                <p className="text-gray-700"><strong>Contact:</strong> {employeeData.phone}, {employeeData.email}</p>
                                <p className="text-green-600 font-semibold">Active</p>
                                <p className="text-gray-700">Job Card Completed : {workHistory.length}</p>
                            </div>
                        </div>
                        <div className="mt-6">
                            <h4 className="text-xl font-semibold mb-4">Work History</h4>
                            <div className="overflow-x-auto">
                                <table className="min-w-full border border-gray-200 rounded-lg">
                                    <thead>
                                    <tr className="bg-gray-100 text-gray-700">
                                        <th className="py-2 px-4 text-left">Job Card ID</th>
                                        <th className="py-2 px-4 text-left">Vehicle Number</th>
                                        <th className="py-2 px-4 text-left">Description</th>
                                        <th className="py-2 px-4 text-left">Completion Date</th>
                                        <th className="py-2 px-4 text-left">Status</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {workHistory.map((record) => (
                                        <tr key={record.jobCardId} className="border-t border-gray-200">
                                            <td className="py-2 px-4">{record.jobCardId}</td>
                                            <td className="py-2 px-4">{record.vehicleNumber}</td>
                                            <td className="py-2 px-4">{record.description}</td>
                                            <td className="py-2 px-4">{new Date(record.completionDate).toLocaleDateString()}</td>
                                            <td className="py-2 px-4">
                                            <span className={`px-2 py-1 text-sm rounded-full text-white ${record.status === 'Completed' ? 'bg-green-500' : 'bg-yellow-500'}`}>
                                                {record.status}
                                            </span>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <br/>
                        <br/>
                        <EmployeeReportChart employeeId={employeeId} workshopId={workshopId} />
                    </div>

            </div>

            </div>
        </div>
    );
};

export default EmployeeProfile;
